import { Pipe, PipeTransform } from '@angular/core';
import { ReportStatus } from '@common/enums';

@Pipe({
  name: 'reportStatus',
  pure: true
})
export class ReportStatusPipe implements PipeTransform {
  private static readonly iconMap: Record<ReportStatus, string> = {
    [ReportStatus.Issue]: 'fa fa-exclamation-circle',
    [ReportStatus.Success]: 'fa fa-check-circle',
    [ReportStatus.Warning]: 'fa fa-exclamation-triangle',
    [ReportStatus.Disabled]: 'fa fa-minus-circle',
    [ReportStatus.Overdue]: 'fa fa-clock-o',
    [ReportStatus.Unknown]: 'fa fa-info-circle'
  };

  private static readonly typeMap: Record<ReportStatus, string> = {
    [ReportStatus.Issue]: 'danger',
    [ReportStatus.Success]: 'success',
    [ReportStatus.Warning]: 'warning',
    [ReportStatus.Disabled]: 'disabled',
    [ReportStatus.Overdue]: 'yellow',
    [ReportStatus.Unknown]: 'muted'
  };

  transform(status: ReportStatus, param: 'icon' | 'type' = 'icon', reason?: string): any {
    if (!status) return '';

    const normalizedStatus = this.normalizeStatus(status, reason);

    switch (param) {
      case 'icon':
        return ReportStatusPipe.iconMap[normalizedStatus] || '';
      case 'type':
        return ReportStatusPipe.typeMap[normalizedStatus] || '';
      default:
        throw new Error(`Caught error manually: Unknown reportStatus pipe param: ${param}`);
    }
  }

  private normalizeStatus(status: ReportStatus, reason?: string): ReportStatus {
    return status === ReportStatus.Disabled && reason ? ReportStatus.Unknown : status;
  }
}
